export enum OfferAdmissionStatusValues {
  NotMarked = "NOT_MARKED",
  AdmittedToRanking = "ADMITTED",
  RejectedFromRanking = "REJECTED",
  NotOffered = "NOT_OFFERED",
  NotInvited = "NOT_INVITED", //nicht durch Nutzer setzbar
}

export type OfferAdmissionStatus = OfferAdmissionStatusValues;
